import React from 'react'

import MessageCard from "../message-cards/index";
import { API } from "@/api/index";
/**
 * 解析来源
 * @param _data 
 * @returns 
 */
export function parseSource(_data) {
    console.log(_data, "返回的数据")
    const getTitle = (num, data, allData) => {
        if (num === 10) {
            return `来源：门户搜索 ${data.length}条`
        } else if (num === 11) {
            return `来源：站群搜索 ${data.length}条`
        } else if (num === 12) {
            return `来源：联网检索 ${data.length}条`
        } else if (num === 1) {
            if (allData?.knowledge_type && allData?.knowledge_type === "qa_pairs") {
                return `来源：问答对【${allData?.knowledge_title}】`
            }
            return `来源：知识库 ${(allData?.docs && allData?.docs.length) ? allData?.docs.length : data.length}个`
        } else if (num === 14) {
            if (allData?.knowledge_type && allData?.knowledge_type === "qa_pairs") {
                return `来源：标注【${allData?.knowledge_title}】`
            }
            return `来源：知识库 ${data.length}个`
        } else if (num === 2) {
            return `来源：数据库`
        } else if (num === 3) {
            return `来源：技能`
        } else {
            return ""
        }
    }

    const getDocsLink = (data) => {
        console.log(data, "单个链接")

        if (data[0].url) {
            return {
                title: `【${data[0].name}】`,
                ...data[0]
            }
        } else {
            if (data[0].kb_id) {
                return {
                    title: `【${data[0].name}】`,
                    url: data[0].url ? data[0].url : API.downDocs + `?zskId=${data[0].kb_id}&filename=${data[0].name}&qId=${_data.qId}`,
                    ...data[0],
                }
            } else {
                return {
                    title: `【${data[0].name}】`,
                    ...data[0]
                }
            }

        }
    }

    if (_data?.src?.[0]?.type === 1 || _data?.src?.[0]?.type === 2 || _data?.src?.[0]?.type === 3 || _data?.src?.[0]?.type === 14 && _data?.src) {
        return (_data?.src && _data?.src.length) ? {
            label: getTitle(_data?.src?.[0]?.type, _data?.src, _data),
            links: _data?.docs ? (_data?.docs.length > 1 ? _data?.docs?.map((item) => {
                if (item.kb_id) {
                    return {
                        ...item,
                        title: `【${item.name}】`,
                        url: item.url ? item.url : API.downDocs + `?zskId=${item.kb_id}&filename=${item.name}&qId=${_data.qId}`,

                    }
                } else {
                    return {
                        title: `【${item.name}】`,
                        ...item
                    }
                }

                // if (item.url) {
                //   return {
                //     title: `【${item.name}】`,
                //     ...item
                //   }
                // } else {
                //   if (item.kb_id) {

                //   } else {

                //   }

                // }
            }) : undefined) : (_data?.src.length > 1 ? _data?.src?.map((item) => {
                return {
                    title: `【${item?.name}】`,
                    url: item?.url,
                };
            }) : undefined)
            ,
            link:
                (_data?.docs && _data?.docs?.length) === 1 ? (_data?.docs?.length === 1 ? getDocsLink(_data.docs) : undefined) : (_data?.src?.length === 1
                    ? (_data?.knowledge_type && _data?.knowledge_type === "qa_pairs" ? undefined : {
                        url: _data?.src[0].url,
                        title: `【${_data?.src[0].name}】`,
                    })
                    : undefined),
        } : undefined
    }

    if (_data?.src?.[0]?.type === 10 || _data?.src?.[0]?.type === 11 || _data?.src?.[0]?.type === 12 && _data?.search_items) {
        return (_data?.search_items && _data?.search_items.length) ? {
            label: getTitle(_data?.src?.[0]?.type, _data?.search_items, _data),
            links: _data?.search_items.length > 1 ? _data?.search_items?.map((item) => {
                return {
                    title: item.title,
                    url: item.url
                }
            }) : undefined,
            link:
                _data?.search_items.length === 1
                    ? {
                        url: _data?.search_items[0].url,
                        title: _data?.search_items[0].title,
                    }
                    : undefined,
        } : undefined
    }
    return _data?.src?.length
        ? {
            links:
                _data?.src?.length > 1
                    ? _data?.src?.map((item) => {
                        return {
                            title: item?.name,
                            url: item?.url,
                        };
                    })
                    : undefined,
            link:
                _data?.src?.length === 1
                    ? {
                        url: _data?.src[0].url,
                        title: _data?.src[0].name,
                    }
                    : undefined,
        }
        : undefined;
}

export function parseHtml(msg) {
    return msg && !msg.chat_qa && msg.html && msg.html.length ? msg.html : undefined
}

export const isMd = (msg) => {
    if ((!msg?.form || msg.form?.type !== 'link') && msg?.answer && msg?.answer !== "") {
        return true;
    }
    return false;
};

export const isIframe = (msg) => {
    if (msg && msg?.form && msg?.form?.type === "link") {
        return true;
    }
    return false;
}

export const parseContent = (msg) => {

    // if (msg?.answer.includes("<｜end▁of▁sentence｜>")) {
    //   msg?.answer.replace("<｜end▁of▁sentence｜>", "")
    // }
    return ((isMd(msg)) ? (
        ((msg?.answer?.includes("<｜end▁of▁sentence｜>") ? msg?.answer?.replace("<｜end▁of▁sentence｜>", "") : msg?.answer) || '')
    ) : (
        ''
        // <MessageCard msgId={msg?.qId} {...msg} />
    ))
}

export const parseExtra = (msg) => {
    return <MessageCard msgId={msg?.qId} {...msg} />
}

export const parseSrcs = (_data) => {
    if (isIframe(_data)) {
        return {
            src: _data?.form?.url,
            defaultHeight: _data?.form?.height
        }
    }
    return undefined
}